import { render } from "./prueba.vue?vue&type=template&id=72ff75c8"
import script from "./prueba.vue?vue&type=script&lang=js"
export * from "./prueba.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__